import { z } from "zod";

import { OutputId } from "../../idTypeBrands.js";
import { createAppSessionEventDefinition } from "../AppSessionEventDefinition.js";

export const DELETE_OUTPUT = createAppSessionEventDefinition({
  type: "DELETE_OUTPUT",
  payloadSchema: z.object({
    outputId: OutputId,
  }),
  logSafe: { outputId: true },
  create: (payload: { outputId: OutputId }) => payload,
  apply: ({ indices, payload: { outputId }, state }) => {
    const warnings: string[] = [];

    const output = state.outputs[outputId];
    if (output == null) {
      warnings.push(`Output not found: ${outputId}`);
    }

    const outputContentIds = indices.outputIdToOutputContentIds[outputId];

    if (outputContentIds == null) {
      warnings.push(`Output content index for output not found: ${outputId}`);
    }

    for (const outputContentId of outputContentIds ?? []) {
      delete state.outputContents[outputContentId];
    }

    delete state.outputs[outputId];

    delete indices.outputIdToOutputContentIds[outputId];
    if (output != null) {
      indices.appSessionCellIdToOutputIds[output.appSessionCellId] =
        indices.appSessionCellIdToOutputIds[output.appSessionCellId]?.filter(
          (id) => id !== output.id,
        ) ?? [];
    }

    return { warnings };
  },
});
